import { bootstrapApplication } from '@angular/platform-browser';
import { enableProdMode } from '@angular/core';
import { MdsConfig } from '@maersk-global/mds-config';
import { App } from './app/app';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';

MdsConfig.iconsDynamicImportPath = '/';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(App, appConfig).catch((err) => console.error(err));
